import { render, staticRenderFns } from "./ContentTypeCallToAction.vue?vue&type=template&id=dc861eb2&scoped=true&"
import script from "./ContentTypeCallToAction.vue?vue&type=script&lang=js&"
export * from "./ContentTypeCallToAction.vue?vue&type=script&lang=js&"
import style0 from "./ContentTypeCallToAction.vue?vue&type=style&index=0&id=dc861eb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc861eb2",
  null
  
)

export default component.exports